import { render } from "./Calendar.vue?vue&type=template&id=2256f418"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"
script.render = render

export default script